module.exports = __webpack_public_path__ + "static/media/signup-background.b26434ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/signup-background.png
// module id = 1033
// module chunks = 0